module.exports = __webpack_public_path__ + "img/products-openapihub-thumbnail.686c414b.jpg";